import { Avatar } from 'antd';
import axios from 'axios';
import React from 'react';
import Naluri from '~/common/api/naluri';
import { currentToken } from '~/common/auth';
import { formatDate } from '~/common/utils';
import {
  NEW_PROFILE_GET_HEALTH_DATA_HISTORY_BEGIN,
  NEW_PROFILE_GET_HEALTH_DATA_HISTORY_DISMISS_ERROR,
  NEW_PROFILE_GET_HEALTH_DATA_HISTORY_FAILURE,
  NEW_PROFILE_GET_HEALTH_DATA_HISTORY_SUCCESS,
} from './constants';

export function getHealthDataHistory(userID) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: NEW_PROFILE_GET_HEALTH_DATA_HISTORY_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      const doRequest = Naluri.get(`/api/expert/health/historical/${userID}`);
      doRequest.then(
        async res => {
          const token = await currentToken();
          const ewa7Result = await axios.get(
            `${process.env.NALURI_APP_COACH_PLATFORM_API_GATEWAY}/assessment/ewa7-result/${userID}`,
            { headers: { Authorization: 'Bearer ' + token } },
          );
          res['ewa7Result'] = ewa7Result.data;
          dispatch({
            type: NEW_PROFILE_GET_HEALTH_DATA_HISTORY_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: NEW_PROFILE_GET_HEALTH_DATA_HISTORY_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetHealthDataHistoryError() {
  return {
    type: NEW_PROFILE_GET_HEALTH_DATA_HISTORY_DISMISS_ERROR,
  };
}

const testEmotionLabel = testResult => {
  if (testResult == null) {
    return 'rgba(255, 255, 255, 0.9)';
  } else {
    const level = testResult.split('-')[1].trim();
    if (level === 'normal') {
      return '#c7c7c7';
    } else if (level === 'mild') {
      return '#b7eb8f';
    } else if (level === 'moderate') {
      return '#ffe58f';
    } else if (level === 'severe') {
      return '#ffa39e';
    } else if (level === 'extremely severe') {
      return '#ffa39e';
    }
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case NEW_PROFILE_GET_HEALTH_DATA_HISTORY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getHealthDataHistoryPending: true,
        getHealthDataHistoryError: null,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_HISTORY_SUCCESS:
      // The request is success
      const emotionalHistory = action.data.emotional_wellbeing;
      let depressionHistory = [];
      let anxietyHistory = [];
      let stressHistory = [];
      let emotionalHealthTestDate = [
        { title: '', dataIndex: 'categoryTitle', key: 'categoryTitle' },
      ];

      emotionalHistory.forEach((hist, index) => {
        const testDate = formatDate(hist.updated_at);

        emotionalHealthTestDate.push({
          title: 'Date - ' + testDate,
          dataIndex: 'result_' + index,
          key: 'result_' + index,
          render: text => (
            <span>
              <Avatar size="small" style={{ backgroundColor: testEmotionLabel(text) }} />
              {text}
            </span>
          ),
        });
        depressionHistory.push({
          ['result_' + index]: `${hist.depression.score} - ${hist.depression.value}`,
          ['test_date-' + index]: testDate,
        });
        anxietyHistory.push({
          [`result_` + index]: `${hist.anxiety.score} - ${hist.anxiety.value}`,
          ['test_date-' + index]: testDate,
        });
        stressHistory.push({
          [`result_` + index]: `${hist.stress.score} - ${hist.stress.value}`,
          ['test_date-' + index]: testDate,
        });
      });

      return {
        ...state,
        emotionalHealthTestDate: emotionalHealthTestDate.slice(0, 3),
        depressionHistory: depressionHistory.slice(0, 2),
        anxietyHistory: anxietyHistory.slice(0, 2),
        stressHistory: stressHistory.slice(0, 2),
        getHealthDataHistoryPending: false,
        getHealthDataHistoryError: null,
        productivityScores: action.data.productivity_scores,
        resilienceScores: action.data.resilience_scores,
        empathyScores: action.data.empathy_scores,
        ewa7Result: action.data.ewa7Result,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_HISTORY_FAILURE:
      // The request is failed
      return {
        ...state,
        getHealthDataHistoryPending: false,
        getHealthDataHistoryError: action.data.error,
      };

    case NEW_PROFILE_GET_HEALTH_DATA_HISTORY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getHealthDataHistoryError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/new-profile/redux/getHealthDataHistory.js